import { createSlice } from '@reduxjs/toolkit';
import { jsonData } from 'constant/jsonData';
import { getDataBasedOnKey } from 'utils/utils';
import { produce } from '../../node_modules/immer/dist/immer';
import { InitialInputs } from 'pages/calculator/ConditionalInputs';

const initialState = {
  selectedKey: new Map(),
  currentLevel: -1,
  currentData: jsonData,
  selectedImages: [],
  selectedDropdownValues: {
    'Roof Type': null,
    'Construction Type': null,
    'Snow Bracket Type': null,
    'Snow Bracket Material': null,
    Sheathing: null,
    'Fastener Type': null,
    Manufacturer: null,
    model: null,
    gauge: null,
    'Mount To': null,
    'Installation Method': null
  },
  inputValues: InitialInputs,
  bracketMaterialPrices: [],
  bracketImagesWithPrices: []
};

// this slice contains information related to bracket caluator
const bracketOptionsSlice = createSlice({
  name: 'bracketOptions',
  initialState,
  reducers: {
    setSelectedKey: (state, action) => {
      const level = action.payload.level;
      const value = action.payload.value;
      const name = action.payload.name;
      const data = action.payload.data;

      state.selectedDropdownValues[name] = value;
      state.currentLevel = level;

      if (data) state.currentData = data;

      state.selectedKey.set(level, {
        value: value, // selected option
        name: name,
        object: getDataBasedOnKey(value, data)
      });
      // deleting extra dropdowns when above drop down changes
      if (state.selectedKey.size > level) {
        for (const mapKey of state.selectedKey.keys()) {
          if (mapKey > level) {
            state.selectedKey.delete(mapKey);
            state.selectedImages = state.selectedImages?.slice(0, mapKey);
          }
        }
      }
    },
    setBracketOptions: (state, action) => {
      const data = action.payload.bracketOptionsData;
      state.selectedKey.clear();
      for (const [key, value] of data.selectedKeyData) {
        state.selectedKey.set(key, value);
      }
      state.currentData = data.currentData;
      state.currentLevel = data.currentLevel;
      state.inputValues = data.inputsData;
      state.selectedImages = data.selectedImages;
    },
    setInputValues: (state, action) => {
      state.inputValues[action.payload.name] = { value: action.payload.value };
    },
    setAllInputData: (state, action) => {
      const inputData = action.payload.inputData;
      state.inputValues = {
        groundSnowLoad: { value: inputData.groundSnowLoad },
        rainLoad: { value: inputData.rainLoad },
        roofSlope: { value: inputData.roofSlope },
        verticalExposure: { value: inputData.verticalExposure },
        horizontalExposure: { value: inputData.horizontalExposure },
        numberOfRoofingSqrs: { value: inputData.numberOfRoofingSqrs }
      };
      state.selectedDropdownValues = {
        'Roof Type': inputData.roofType,
        'Construction Type': inputData.constructionType,
        'Snow Bracket Type': inputData.bracketType,
        'Snow Bracket Material': inputData.bracketMaterial,
        Sheathing: inputData.sheathing,
        'Fastener Type': inputData.fastenerType,
        Manufacturer: inputData.manufacturer,
        model: inputData.model,
        gauge: inputData.gauge,
        'Mount To': inputData.mountTo,
        'Installation Method': inputData.installationMethod
      };
    },
    setSelectedImage: (state, action) => {
      let imageReceived = action.payload.imgData;
      if (imageReceived?.label === 'Snow Bracket Type')
        imageReceived = state.bracketImagesWithPrices?.find(
          (image) => image?.tag === imageReceived?.tag
        );

      return produce(state, (draft) => {
        const index = draft.selectedImages.findIndex(
          (image) => image?.label == imageReceived?.label
        );

        if (index === -1) {
          draft.selectedImages.push(imageReceived);
        } else {
          draft.selectedImages.splice(index, 1, imageReceived);
        }
      });
    },
    setbracketMaterialPrices: (state, action) => {
      state.bracketMaterialPrices = action.payload.bracketsPriceDataList;
    },
    setBaracketImagesWithPrices: (state, action) => {
      state.bracketImagesWithPrices = action.payload.bracketImagesWithPrices;
    },
    removeSelectedImage: (state, action) => {
      state.selectedImages = state.selectedImages.filter((image) => image.tag !== action.image.tag);
    },
    clearBracketOptionsData: (_) => initialState,
    clearInputValues: (state, _) => {
      state.inputValues = {
        groundSnowLoad: { value: '' },
        rainLoad: { value: '' },
        roofSlope: { value: '' },
        verticalExposure: { value: '' },
        horizontalExposure: { value: '' },
        numberOfRoofingSqrs: { value: '' }
      };
      // return produce(state, (draft) => {
      //   return new Proxy(draft, {
      //     get(target, prop) {
      //       if (prop in target) {
      //         return null;
      //       }
      //       return Reflect.get(target, prop);
      //     }
      //   });
      // });
    }
  }
});

export const {
  setSelectedKey,
  setBracketOptions,
  setSelectedImage,
  setbracketMaterialPrices,
  removeSelectedImage,
  clearBracketOptionsData,
  setInputValues,
  setAllInputData,
  clearInputValues,
  setBaracketImagesWithPrices
} = bracketOptionsSlice.actions;
export default bracketOptionsSlice.reducer;
